import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783676c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-left-column" }

import TopEntitiesTable from '@/components/dashboard/TopEntitiesTable.vue';
import AlertsWidget from '@/components/dashboard/AlertsWidget.vue';
import { useDashboardStore } from '@/core/hooks/useDashboardStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardLeftColumn',
  setup(__props) {

const { permissions } = useDashboardStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopEntitiesTable, { compact: "" }),
    (_unref(permissions).canViewAlerts)
      ? (_openBlock(), _createBlock(AlertsWidget, {
          key: 0,
          compact: ""
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})